/** Port of cdc-web `src/utils/matchEventTitle.ts`（1:1）。 */

/** Single source of truth for match delimiter detection */
export const MATCH_DELIMITER_REGEX = / (vs|@) /

/** Parse a match event title into left/right parts and delimiter */
export function parseMatchEventTitle(title: string) {
  const match = title.match(/^(.+?) (vs|@) (.+)$/)
  if (!match) {
    return { titleLeft: '', titleRight: '', delimiter: '' as const }
  }
  return {
    titleLeft: match[1].trim(),
    titleRight: match[3].trim(),
    delimiter: match[2] as 'vs' | '@',
  }
}
